/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, arrayOf, shape, string, object,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import VIsmallcard from '../../assets/svg/VIsmallcard';
import MCsmallcard from '../../assets/svg/MCsmallcard';
import AXsmallcard from '../../assets/svg/AXsmallcard';
import DSsmallcard from '../../assets/svg/DSsmallcard';
import PYsmallcard from '../../assets/svg/PYsmallcard';
import APsmallcard from '../../assets/svg/APsmallcard';
import GPsmallcard from '../../assets/svg/GPsmallcard';
import VMsmallcard from '../../assets/svg/VMsmallcard';

const cardIcons = {
    VI: VIsmallcard, // Visa card
    MC: MCsmallcard, // Master card
    AX: AXsmallcard, // Amex card
    DS: DSsmallcard, // Discover card
    PY: PYsmallcard, // PayPal
    AP: APsmallcard, // Apple Pay
    GP: GPsmallcard, // Google Pay
    VM: VMsmallcard, // Venmo
};

const styles = () => ({
    cardIconsRoot: {
        position: 'relative',
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiSvgIcon-root"]': {
            width: '36px',
            position: 'absolute',
            top: '-5px',
        },
    },
    cardName: {
        marginLeft: '45px',
    },
});
class WalletInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = { defaultCard: '' };
    }

    getCardTypeById = (cardtypes, id) => {
        let cardTypeName = null;
        if (cardtypes) {
            const listCardType = cardtypes.filter((c) => c.id === id) || [];
            if (listCardType.length) {
                cardTypeName = listCardType[0].name;
            }
        }
        return cardTypeName;
    }

    getCardTypeIcon = (id) => {
        const IconType = cardIcons[id];
        return IconType ? <IconType /> : '';
    }

    handleSetDefaultCardClicked = (walletId) => {
        const { onSetDefaultCard } = this.props;
        this.setState({ defaultCard: walletId }, () => {
            onSetDefaultCard(walletId);
        });
    };

    render() {
        // eslint-disable-next-line object-curly-newline
        const {
            wallet,
            cardTypes,
            onAddCard,
            onRemoveCard,
            onEditCard,
            classes,
        } = this.props;
        const { defaultCard } = this.state;
        const setAdDefaultButton = (walletId) => (defaultCard === walletId ? (
            <div className="margin-top">Set As Default...</div>
        ) : (
            <button
                className="set-default-cc-btn link margin-top"
                onClick={() => this.handleSetDefaultCardClicked(walletId)}
                type="button"
            >
                Set As Default
            </button>
        ));

        return (
            <>
                <h2>Your Payment Methods</h2>
                {wallet.map((w, i) => (
                    <div key={w.walletId}>
                        <div className="split">
                            <div className="bold">
                                <span className={classes.cardIconsRoot}>{this.getCardTypeIcon(w.payType === 'CC' ? w.cardType : w.payType)}</span>
                                <span className={classes.cardName}>{this.getCardTypeById(cardTypes, w.payType === 'CC' ? w.cardType : w.payType)}</span>
                            </div>
                            <div className="flex-none">
                                {w.payType === 'CC'
                                    && (
                                        <button
                                            className="edit-cc-btn link"
                                            onClick={() => onEditCard(w)}
                                            type="button"
                                        >
                                            Edit
                                        </button>
                                    )}
                                {w.subsIndicator === '0' ? (
                                    <button
                                        className="remove-cc-btn link margin-left"
                                        onClick={() => onRemoveCard(w.walletId)}
                                        type="button"
                                    >
                                        Delete
                                    </button>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div>
                            &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                            {w.lastFourDigits}
                        </div>
                        <div>{w.cardHolderName}</div>
                        <div className="split">
                            <div>Expires: {w.expiryDate}</div>
                            <div className="flex-none">
                                {w.subsIndicator === '1' ? 'DEFAULT*' : ''}
                            </div>
                        </div>
                        {w.subsIndicator === '0'
                            ? setAdDefaultButton(w.walletId)
                            : ''}
                        <div
                            className={
                                w.subsIndicator === '1'
                                    ? 'margin-top small bold'
                                    : 'display-none'
                            }
                        >
                            *Use this card for Subscription &amp; Passport
                            membership
                        </div>
                        {wallet.length - 1 > i ? (
                            <Divider className="margin-top margin-bottom" />
                        ) : (
                            ''
                        )}
                    </div>
                ))}
                {wallet.length === 0 ? (
                    <p>
                        You do not have any saved credit cards on file. Click
                        the Add Card button below to add a credit card.
                    </p>
                ) : (
                    ''
                )}
                <div
                    className={wallet.length > 0 ? 'row margin-top-2x' : 'row'}
                >
                    <Button
                        data-test="my-account-add-new-credit-card-button"
                        variant="contained"
                        className="buttonHD margin-top margin-bottom-2x"
                        onClick={() => onAddCard()}
                    >
                        Add New Credit Card
                    </Button>
                </div>
            </>
        );
    }
}

WalletInfo.propTypes = {
    wallet: arrayOf(
        shape({
            walletId: string.isRequired,
            cardType: string.isRequired,
            payType: string.isRequired,
            cardHolderName: string.isRequired,
            cardNumber: string.isRequired,
            lastFourDigits: string.isRequired,
            expiryDate: string.isRequired,
            status: string,
            subsIndicator: string,
        }),
    ).isRequired,
    cardTypes: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    onAddCard: func.isRequired,
    onEditCard: func.isRequired,
    onRemoveCard: func.isRequired,
    onSetDefaultCard: func.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(WalletInfo);
